export const usePosition = () => {
  const position = ref<{ lat: number, lng: number } | null>(null)

  const updatePosition = () => {
    navigator.geolocation.getCurrentPosition((currentPosition) => {
      position.value = {
        lat: currentPosition.coords.latitude,
        lng: currentPosition.coords.longitude
      }
    }, () => position.value = null)
  }

  onMounted(() => {
    updatePosition()

    navigator.permissions.query({ name: 'geolocation' }).then((permissionStatus) => {
      permissionStatus.addEventListener('change', () => {
        updatePosition()
      })
    })
  })

  return {
    position,
    updatePosition
  }
}